import {SymbolPackApiDto} from "./restModels";

export class SymbolPack {
	constructor(public readonly id: string, public readonly name: string) {}

	public static fromJson(json: SymbolPackApiDto): SymbolPack {
		return new SymbolPack(json.id, json.name);
	}
}
